import {i18n} from '@/plugins/i18n';
import {transmitDescription, transmitDescriptionStr} from '@/constants/transmitDescription';
import {transmitType, transmitTypeStr} from "@/constants/transmitType";

export default [
    {
        field: 'balance',
        title: i18n.t('label.balance'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('label.amount_rial'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'transaction_type',
        title: i18n.t('label.type'),
        sortable: false,
        textAlign: 'center',
        template: row => {
            let type = ''
            if (row.transaction_type  === 'CREDIT') {
                type = "<span class='badge badge-success'>واریز</span>"
            }
            else {
                type = "<span class='badge badge-danger'>برداشت</span>"
            }
            return type;
        },
    },
    {
        field: 'describe_transaction',
        title: i18n.t('label.description'),
        sortable: false,
        textAlign: 'center',
        template: row => {
            console.log(row.describe_transaction)
            if (row.describe_transaction === transmitDescription.reversal) {
                row.describe_transaction = transmitDescriptionStr.get(transmitDescription.reversal);
            } else if (row.describe_transaction === transmitDescription.paya_wage) {
                row.describe_transaction = transmitDescriptionStr.get(transmitDescription.paya_wage);
            } else if (row.describe_transaction === transmitDescription.paya) {
                row.describe_transaction = transmitDescriptionStr.get(transmitDescription.paya);
            } else if (row.describe_transaction === transmitDescription.internal) {
                row.describe_transaction = transmitDescriptionStr.get(transmitDescription.internal);
            }

            return `<span>${row.describe_transaction}</span>`;
        },
    },
    {
        field: 'payment_date',
        title: i18n.t('label.date'),
        sortable: false,
        textAlign: 'center',
    },

    {
        field: 'payment_id',
        title: i18n.t('label.payment_id'),
        sortable: false,
        textAlign: 'center',
    }
];